import { Suspense as ReactSuspense, type ReactNode } from 'react';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Skeleton from '@mui/material/Skeleton';

interface SuspenseProps {
  children: ReactNode;
  variant?: 'spinner' | 'skeleton';
  height?: number | string;
}

function SpinnerFallback() {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 200,
        width: '100%',
      }}
    >
      <CircularProgress size={36} />
    </Box>
  );
}

function SkeletonFallback({ height }: { height: number | string }) {
  return (
    <Box sx={{ width: '100%', p: 2 }}>
      <Skeleton variant="text" width="60%" height={32} />
      <Skeleton variant="text" width="80%" height={24} sx={{ mt: 1 }} />
      <Skeleton variant="rectangular" width="100%" height={height} sx={{ mt: 2 }} />
    </Box>
  );
}

export function AppSuspense({ children, variant = 'spinner', height = 200 }: SuspenseProps) {
  const fallback =
    variant === 'skeleton' ? <SkeletonFallback height={height} /> : <SpinnerFallback />;

  return <ReactSuspense fallback={fallback}>{children}</ReactSuspense>;
}
